import { EditorPageConfig } from '@website-editor/WebsiteEditor.types';
import { AccommodationPropertyPhotosQuery, AccommodationsInfoFragment, TravelMapComponentFragment } from '@graphql/generated';
import { EventVenue } from '@shared/utils/eventPlace';
import React from 'react';
import { NormalizedTravelReservationBookingDetailsQuery } from '../components/GuestHotelBookingsList/GuestHotelBookingsList.types';

export interface AccommodationsContextProps
  extends Readonly<{
    componentData: TravelMapComponentFragment;
    containerId: string;
    pageSlug: string;
    eventHandle: string;
    accommodationsData?: AccommodationsInfoFragment;
    accommodationPropertyPhotos?: AccommodationPropertyPhotosQuery;
    venueData?: EventVenue;
    loadingData?: boolean;
    isSuperAdmin?: boolean;
    pageConfig: EditorPageConfig;
    bookingDetailsData?: NormalizedTravelReservationBookingDetailsQuery;
    loadingBookingDetails?: boolean;
  }> {}

export const AccommodationsContext = React.createContext<AccommodationsContextProps>({
  componentData: {} as TravelMapComponentFragment,
  containerId: '',
  pageSlug: '',
  eventHandle: '',
  accommodationsData: {} as AccommodationsInfoFragment,
  accommodationPropertyPhotos: {} as AccommodationPropertyPhotosQuery,
  venueData: undefined,
  loadingData: false,
  isSuperAdmin: false,
  pageConfig: {} as EditorPageConfig,
  bookingDetailsData: {} as NormalizedTravelReservationBookingDetailsQuery,
});
